import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import logo from '../../assets/logo.png';
import { verifyCode } from '../../features/auth/auth.slice';
import Spinner from '../utilities/Spinner';

const CheckMail = ({ setAuthType }) => {
  const { email, loading, emailVerified } = useSelector((state) => state.auth);
  const [code, setCode] = useState('');

  const dispatch = useDispatch();

  useEffect(() => {
    if (emailVerified) {
      setAuthType('setnewpassword');
    }
  }, [emailVerified]);
  return (
    <>
      <>
        <img src={logo} alt="Postager Logo" />
        <p className="font-semibold">Check Your Email</p>
      </>
      <form
        className="space-y-5 px-7 w-full pt-5"
        onSubmit={(e) => {
          e.preventDefault();
          dispatch(
            verifyCode({
              email,
              code,
            })
          );
        }}
      >
        <p className="text-sm text-center">
          We have sent a password reset code to {email}
        </p>
        <div>
          <input
            type="password"
            class="bg-gray-50 border border-gray-400 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full p-2"
            placeholder="Enter Code"
            onChange={(e) => setCode(e.target.value)}
            required
          />
          <a
            href="#"
            className="text-sm pt-1 float-right mb-3 hover:underline"
            onClick={() => setAuthType('forgotpassword')}
          >
            Didn't receive the email?{' '}
            <span className="font-bold">Resend Again</span>
          </a>
        </div>

        <div className="flex flex-col justify-center items-center w-full space-y-3">
          <button
            className={`text-white   focus:ring-4 ${
              loading ? 'bg-blue-300' : 'bg-darkblue hover:bg-blue-800'
            } focus:outline-none focus:ring-blue-300 font-medium rounded-md text-sm w-full px-5 py-2 text-center self-center mt-5 flex justify-center`}
            type="submit"
          >
            {loading ? <Spinner sm={true} /> : 'Verify Email'}
          </button>

          <a
            href="#"
            className="text-sm hover:underline"
            onClick={() => setAuthType('login')}
          >
            Back To Login Page
          </a>
        </div>
      </form>
    </>
  );
};

export default CheckMail;
